import { UNRELEASED_FEATURES_ENABLED } from '../../appConfig';
import { MY_CONTENT_ROUTES } from '../../Base.constants';
import { LinkGroupRoute } from '../../components/LinkGroup/LinkGroup';

export const MY_CONTENT_SUB_HEADER_ROUTES: LinkGroupRoute[] = [
  { to: MY_CONTENT_ROUTES.articles(), label: 'Articles' },
  { to: MY_CONTENT_ROUTES.watchlists(), label: 'Watchlists' },
  { to: MY_CONTENT_ROUTES.searches, label: 'Searches' },
  ...(UNRELEASED_FEATURES_ENABLED ? [{ to: MY_CONTENT_ROUTES.covenants, label: 'Covenants' }] : []),
  { to: MY_CONTENT_ROUTES.managePreferences, label: 'Preferences' },
];
